import React from 'react';
import Configuration from '../../utils/configuration';

const Logo = (props) => (
	<div className="logo flex item grow">
		<a href="http://www.asturiascongresos.com" target="_blank" rel="noopener noreferrer">
			<img
				src={`${Configuration.RESOURCES_URL}logo/logo-w.png`}
				alt={`${Configuration.SITE_NAME}`}
				title={`${Configuration.SITE_NAME}`}
			/>
		</a>
		<a href="https://www.gijon.es/" target="_blank" rel="noopener noreferrer">
			<img
				src={`${Configuration.RESOURCES_URL}logo/logo_ayto.png`}
				alt={`${Configuration.SITE_NAME}`}
				title={`${Configuration.SITE_NAME}`}
			/>
		</a>
	</div>
);

export default Logo;
